// MyInput.tsx
import { extendVariants, Checkbox } from "@nextui-org/react";
export const CheckboxPrimary = extendVariants(Checkbox, {
  variants: {
    // <- modify/add variants
    size: {
      brand: {
        // icon: "!size-4",
        wrapper: "!size-[17px]"
      }
    },
    radius: {
      brand: {
        wrapper: "after:!rounded before:!rounded !rounded mr-1"
      }
    },
    textSize: {
      base: {
        label: "text-xs leading-1"
      }
    },
    removeLabel: {
      true: {
        label: "hidden"
      },
      false: {}
    }
  },
  defaultVariants: {
    color: "secondary",
    size: "brand",
    radius: "brand",
    textSize: "base",
    removeLabel: false
  }
});